// extracted by mini-css-extract-plugin
module.exports = {"StrollerDetailRating":"xn_a bhj_a bhj_x","StrollerDetailRating__muted":"xn_b bhj_fi"};